<div class="flex w-full flex-col bg-white py-2 rounded-xl">
  <div
    class="flex w-full justify-between bg-white py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
  >
    <div class="flex gap-4 items-center">
      <div class="h-10 w-1 bg-primary"></div>
      <span>Personal Details</span>
    </div>
    <div
      (click)="personalDetails = !personalDetails"
      class="p-1 rounded-full h-6 w-6 bg-gray-300"
    >
      <img src="../../../assets/image/Arrows.svg" />
    </div>
  </div>
  <div *ngIf="personalDetails" class="p-5 w-full">
    <form
      [formGroup]="customerPersonalForm"
      class="p-5 grid md:grid-cols-2 grid-cols-1 gap-4 w-full"
    >
      <!-- <div class="w-full gap-2 flex flex-col">
        <span>Pay Id</span>

        <input
          formControlName="PayId"
          name="PayId"
          placeholder="Enter Your Pay ID"
          class="w-full border p-2 rounded-md outline-none"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Partner Name</span>

        <input
          formControlName="Businessname"
          name="Businessname"
          placeholder="Enter Your partner name"
          class="w-full border p-2 rounded-md outline-none"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>First name</span>

        <input
          formControlName="firstname"
          name="firstname"
          placeholder="Enter your First Name"
          class="w-full border p-2 rounded-md outline-none"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Reseller ID</span>

        <input
          formControlName="resellerId"
          name="resellerId"
          placeholder="Enter Your reseller ID"
          class="w-full border p-2 rounded-md outline-none"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Last Name</span>

        <input
          formControlName="lastname"
          name="lastname"
          placeholder="Enter Your Last Name"
          class="w-full border p-2 rounded-md outline-none"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Industry Category</span>

        <input
          formControlName="industryCategory"
          name="industryCategory"
          placeholder="Enter Your industry category"
          class="w-full border p-2 rounded-md outline-none"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Company Name</span>

        <input
          formControlName="companyName"
          name="companyName"
          placeholder="Enter Your Company Name"
          class="w-full border p-2 rounded-md outline-none"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Email Id</span>

        <input
          formControlName="email"
          name="email"
          placeholder="Enter Your Email ID"
          class="w-full border p-2 rounded-md outline-none"
        />
        <div
          *ngIf="customerPersonalForm.controls['email'].errors?.['email']"
          class="text-red-500"
        >
          Invalid Email Address
        </div> 
      </div>-->

      <!-- new data -->

      <div class="w-full gap-2 flex flex-col">
        <span>Full Name</span>

        <input
          type="text" [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin'"
          formControlName="name"
          name="name"
          placeholder="Enter Full Name"
          class="w-full border p-2 rounded-md outline-none"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Mobile</span>

        <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin'"
          formControlName="phone"
          name="phone"
          maxlength="10"
          placeholder="Enter Mobile Number"
          class="w-full border p-2 rounded-md outline-none"
          (keypress)="keyPressNumbers($event)"
        />
      </div>
      <div class="w-full gap-2 flex flex-col" [ngStyle]="{ 'pointer-events': customerPersonalForm.get('businessName')?.value ? 'none' : 'all' }">
        <span>Partner Name</span>

        <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin'"
          type="text"
          formControlName="businessName"
          name="businessName"
          placeholder="Enter Your Business Name"
          class="w-full border p-2 rounded-md outline-none"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Telephone Number</span>

        <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin'"
          maxlength="10"
          formControlName="alternatePhone"
          name="alternatePhone"
          placeholder="Enter Telephone Number"
          class="w-full border p-2 rounded-md outline-none"
          (keypress)="keyPressNumbers($event)"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Address</span>

        <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin'"
          type="text"
          formControlName="address"
          name="address"
          placeholder="Enter Address"
          class="w-full border p-2 rounded-md outline-none"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Email ID</span>

        <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin'"
          type="email"
          formControlName="email"
          name="email"
          placeholder="Enter Your Email ID"
          class="w-full border p-2 rounded-md outline-none"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>State</span>

        <select
          (change)="onStateSelect($event)"
          formControlName="state"
          name="state"
          class="w-full border p-2 rounded-md outline-none"
        >
        <option value="" disabled>Select State</option>
          <option *ngFor="let state of stateList" [value]="state.stateId">
            {{ state.title }}
          </option>
        </select>
      </div>
      <!-- <div class="w-full gap-2 flex flex-col">
        <span>Reseller ID</span>

        <input
          type="text"
          formControlName="resellerId"
          name="resellerId"
          placeholder="Enter Reseller ID"
          class="w-full border p-2 rounded-md outline-none"
        />
      </div> -->
      <div class="w-full gap-2 flex flex-col">
        <span>City</span>

        <select
          (change)="onCitySelect($event)"
          formControlName="city"
          name="city"
          placeholder="Enter City"
          class="w-full border p-2 rounded-md outline-none"
        >
        <option value="" disabled>Select City</option>
          <option *ngFor="let city of cityList" [value]="city.cityId">
            {{ city.title }}
          </option>
        </select>
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Industry Category</span>
        
        <select class="w-full border p-2 rounded-md outline-none" (change)="onIndustrySelect($event)"
        formControlName="industryType">
          <option *ngFor="let industryType of industryTypeList" 
          [value]="industryType?.industryTypeId">{{ industryType.title }} </option>
        </select>

        <!-- <input
          type="text"
          formControlName="industryCategory"
          name="industryCategory"
          placeholder="Enter Industry Category"
          class="w-full border p-2 rounded-md outline-none"
        /> -->
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Postal Code</span>

        <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin'"
          
          maxlength="6"
          (keypress)="keyPressNumbers($event)"
          formControlName="pincode"
          name="pincode"
          placeholder="Enter Postal Code"
          class="w-full border p-2 rounded-md outline-none"
        />
      </div>
      <!-- <div class="w-full gap-2 flex flex-col">
        <span>Country</span>

        <select
          formControlName="country"
          name="country"
          placeholder="Enter Country"
          class="w-full border p-2 rounded-md outline-none"
        ><option selected>Select Country</option></select>
      </div>  -->
    </form>
  </div>
</div>
